import { Component, input } from '@angular/core';
import { IRisk, riskIconKey } from '@webapp/risk-core';
import { IconComponent, IconType } from '@webapp/ui';
@Component({
	selector: 'app-risk',
	standalone: true,
	imports: [IconComponent],
	templateUrl: './risk.component.html',
	styleUrl: './risk.component.scss',
})
export class RiskComponent {
	risk = input<IRisk>();

	getIcon(): IconType {
		return riskIconKey(this.risk()?.icon ?? '') as IconType;

	}

}
